__turbopack_context__.v({
  "createPlaceholder": "entitySelector-module-scss-module__GaA7Yq__createPlaceholder",
  "createPlaceholderIcon": "entitySelector-module-scss-module__GaA7Yq__createPlaceholderIcon",
  "createPlaceholderLabel": "entitySelector-module-scss-module__GaA7Yq__createPlaceholderLabel",
  "entitySelector": "entitySelector-module-scss-module__GaA7Yq__entitySelector",
  "preview": "entitySelector-module-scss-module__GaA7Yq__preview",
});
